module.exports = __webpack_public_path__ + "img/mariage-2-thumbnail.ae3fe3d6.jpg";